import { findProjectByName } from '@shaojiang/data/profile';
import { Project } from '@shaojiang/types/profile';

export default function useProjectByName(name: string): Project | null {
  return findProjectByName(name);
}
